export default __webpack_public_path__ + "static/media/img--kitchen-dark.80d25441.jpg";